import type {Pointer, PS} from '@wix/document-services-types'
import * as santaCoreUtils from '@wix/santa-core-utils'
import dataModel from '../dataModel/dataModel'
import {POPUP_CONTAINER} from './consts'

function getPopupContainer(ps: PS, popupPagePointer: Pointer) {
    const childrenPointers = ps.pointers.components.getChildren(popupPagePointer)

    if (childrenPointers.length > 1) {
        throw new Error(
            `More than one child of the popup page was found. A popup page must have only single direct child of type ${Array.from(
                Object.values(POPUP_CONTAINER)
            ).join(', ')}`
        )
    }
    if (childrenPointers.length < 1) {
        throw new Error('No direct child of the popup page was found')
    }

    let candidatePointer = childrenPointers[0]
    const candidateType = ps.dal.get(ps.pointers.getInnerPointer(candidatePointer, 'componentType'))

    if (!Object.values(POPUP_CONTAINER).includes(candidateType)) {
        throw new Error(
            `Direct child of the popup is of type ${candidateType}. Expected types: ${Array.from(
                Object.values(POPUP_CONTAINER)
            ).join(', ')}`
        )
    }

    if (candidateType === POPUP_CONTAINER.BUILDER_SYSTEM) {
        const builderPopupContainerChildren = ps.pointers.components.getChildren(candidatePointer)
        if (builderPopupContainerChildren.length !== 1) {
            throw new Error(
                `${POPUP_CONTAINER.BUILDER_SYSTEM} must have exactly one child. Found ${builderPopupContainerChildren.length} children`
            )
        }
        candidatePointer = builderPopupContainerChildren[0]
    }

    return candidatePointer
}

function isPopupContainer(componentType: string) {
    return componentType === santaCoreUtils.constants.POPUP.POPUP_CONTAINER.COMPONENT_TYPE
}

function isPopupFullWidth(ps: PS, popupPointer: Pointer) {
    const popupContainerPointer = getPopupContainer(ps, popupPointer)
    const popupContainerProps = dataModel.getPropertiesItem(ps, popupContainerPointer)
    return popupContainerProps.alignmentType === 'fullWidth'
}

function isPopup(ps: PS, pageId: string) {
    if (pageId === 'masterPage') {
        return false
    }
    const pageDataItemPointer = ps.pointers.data.getDataItemFromMaster(pageId)
    return ps.dal.get(ps.pointers.getInnerPointer(pageDataItemPointer, 'isPopup'))
}

export default {
    getPopupContainer,
    isPopupContainer,
    isPopupFullWidth,
    isPopup
}
